import { getDefaultMiddleware } from '@databases/utils/redux/redux';
import { configureStore } from '@reduxjs/toolkit';

import { defaultReducers, getAppStoreUtils } from './redux';

export const appStore = configureStore({
  reducer: {
    ...defaultReducers,
  },
  middleware: getDefaultMiddleware(),
});

export type AppRootState = ReturnType<typeof appStore.getState>;
export const appStoreUtils = getAppStoreUtils<AppRootState>();
